import React from 'react';
import { Button, Card, CardBody, Col, Container, Form, Row } from 'reactstrap';

const Logout = (props) => (
    <div className='app flex-row align-items-center'>
        <Container>
            <Row className='justify-content-center'>
                <Col md='9' lg='7' xl='6'>
                    <Card className='mx-4'>
                        <CardBody className='p-4'>
                            <Form>
                                <h1>Sessão finalizada</h1>
                                <p className='text-muted mb-5'>Para realizar o login novamente, clique no link abaixo</p>
                                <Button onClick={() => (window.location.href = '/')} color='success' block>
                                    Efetuar login
                                </Button>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    </div>
);

export default Logout;
